import { match } from 'ts-pattern';
import { PopularSearchResponse, PopularSearchType } from '@modules/libs/graphql/generated/graphql';
import { ISearchTag } from '@modules/search/domain/models/searchTag.model';
export class PopularSearchEntityMapper {
  public static toDomain(searchResultResponse: PopularSearchResponse[]): ISearchTag[] {
    return searchResultResponse.map(({
      id,
      title,
      type,
      slugUrl
    }) => {
      return {
        id: id.toString(),
        linkOut: this.mapLinkOut(type, slugUrl),
        text: title
      };
    });
  }
  private static mapLinkOut(type: PopularSearchType, slugUrl: string): string {
    const searchType = this.mapPopularType(type);
    return `/${searchType}/${slugUrl}`;
  }
  private static mapPopularType(type: PopularSearchType) {
    return match(type).with(PopularSearchType.Product, () => 'product').with(PopularSearchType.Recipe, () => 'recipe').with(PopularSearchType.TipsTricks, () => 'tips-tricks').exhaustive();
  }
}